/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { OcppMessage, OcppMessageInitialState } from '../../interface/ocpp-message.interface';

// Initial state
const initialState: OcppMessageInitialState = {
  messages: [],
  currentMessage: {},
};

// Create the slice
export const ocppMessageSlice = createSlice({
  name: 'ocpp-message',
  initialState,
  reducers: {
    /**
     * Function to update to received message to existing message
     * @param {any} state - The current state.
     * @param {any} action - The action object.
     */
    pushReceivedMessage: (state: OcppMessageInitialState, action: PayloadAction<OcppMessage>) => {
      state.messages.push(action.payload);
    },
    /**
     * Function to update to received message to existing message
     * @param {any} state - The current state.
     * @param {any} action - The action object.
     */
    lastReceiveMessage: (state: OcppMessageInitialState, action: PayloadAction<OcppMessage>) => {
      state.currentMessage = action.payload;
    },
  },
});

// Export the actions
export const { pushReceivedMessage, lastReceiveMessage } = ocppMessageSlice.actions;

// Export the reducer
export default ocppMessageSlice.reducer;
